import { render, staticRenderFns } from "./query.vue?vue&type=template&id=c39c0b08&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"
import style0 from "./query.vue?vue&type=style&index=0&id=c39c0b08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39c0b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c39c0b08')) {
      api.createRecord('c39c0b08', component.options)
    } else {
      api.reload('c39c0b08', component.options)
    }
    module.hot.accept("./query.vue?vue&type=template&id=c39c0b08&scoped=true", function () {
      api.rerender('c39c0b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugList/query.vue"
export default component.exports